import { API } from "../../../../../../utility/API"

//************************************//
export const _sendOtp = (callback, callbackErr) => {
  // persistStore().purge()
  API.get(`authenticate/resource/otp/send_otp`)
    .then(function ({ data }) {
      callback({ data })
    })
    .catch(function (error) {
      callbackErr(error.response.data)
    })
}
//************************************//
export const _disable2FA = (data, callback, callbackErr) => {
    // persistStore().purge()
    API.post(`authenticate/resource/otp/disable`, data)
      .then(function ({ data }) {
        callback({ data })
      })
      .catch(function (error) {
        callbackErr(error.response.data)
      })
  }
